// src/data/menuData.js
export const categories = [
  { id: "starters", label: "Starters" },
  { id: "mains", label: "Main Dishes" },
  { id: "desserts", label: "Desserts" },
  { id: "drinks", label: "Drinks" },
];

export const products = {
  starters: [
    { id: "spring-rolls", name: "Spring Rolls", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
    { id: "salad", name: "Fresh Salad", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
  ],
  mains: [
    { id: "steak", name: "Grilled Steak", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true},
    { id: "pasta", name: "Italian Pasta", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
  ],
  desserts: [
    { id: "cake", name: "Chocolate Cake", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
    { id: "ice-cream", name: "Ice Cream", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
  ],
  drinks: [
    { id: "coffee", name: "Coffee", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
    { id: "juice", name: "Orange Juice", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: false,withoutViewCompany:true },
  ],
};